import { inject, InjectionToken, signal, WritableSignal } from '@angular/core';

export const CURRENT_TEMPLATE = new InjectionToken<WritableSignal<string | undefined>>('CurrentTemplate', {
  providedIn: 'root',
  factory: () => signal<string | undefined>(undefined)
});

/**
 * Makes the current template global and available for injection into footer components
 */
export function useCurrentTemplate(template?: string | undefined) {
  return () => {
    const currentTemplate = inject(CURRENT_TEMPLATE);
    if (template) {
      currentTemplate.set(template);
    }
    return currentTemplate.asReadonly();
  };
}

export function setCurrentTemplate(template?: string | undefined) {
  const currentTemplate = inject(CURRENT_TEMPLATE);
  currentTemplate.set(template);
}
